import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';

@Component({
  selector: 'app-radio-group-payments',
  templateUrl: './radio-group-payments.component.html',
  styleUrls: ['./radio-group-payments.component.scss']
})
export class RadioGroupPaymentsComponent implements OnInit {

  constructor() { }
  paymentType: string="";
  @Output() choosenPaymentType = new EventEmitter<string>();
  ngOnInit() {
    this.paymentType ="אשראי";
  }

  chooseType(paymentType:string) {
    this.paymentType = paymentType;
    this.choosenPaymentType.emit(paymentType);
  }

}
